var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuturesMain = function SvgFuturesMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.269,
    height: 1.401,
    x: 13.919,
    y: 8.801,
    rx: 0.701
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.35,
    height: 1.401,
    x: 11.838,
    y: 11.386,
    rx: 0.701
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.106 4.565h-5.004a2.827 2.827 0 0 0-2.827 2.827v10.89c0 .252.204.456.455.456h7.375a2.827 2.827 0 0 0 2.828-2.827V7.39a2.827 2.827 0 0 0-2.828-2.826M12.102 3.15a4.24 4.24 0 0 0-4.24 4.24v2.595H5.48a2.827 2.827 0 0 0-2.827 2.827v4.04c0 1.805 1.45 3.27 3.247 3.298h3.68v-.006q.074.006.15.006h7.374a4.24 4.24 0 0 0 4.241-4.24V7.39a4.24 4.24 0 0 0-4.24-4.24zM5.481 11.4H7.86v6.883a.455.455 0 0 1-.455.455H5.952a1.885 1.885 0 0 1-1.884-1.885v-4.04c0-.78.632-1.413 1.413-1.413",
    clipRule: "evenodd"
  })));
};
export default SvgFuturesMain;